



























































import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import Input from '../../core/components/Input.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    formatDate,
    parseFloatNumber,
    matchedIndexIdInArray,
    getUniqueId,
    getIdsFromList,
    getIndexFromList
} from '../../core/utils';
import { booleanFormatter, formattedDate } from '../../core/utils/table-formatters';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Button from '../../core/components/Button.vue';
import MultipleSelect from '../../core/components/MultipleSelect.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import { daysToReprocess, sowingReprocessData, vehiclesToReprocess } from '../api/models';

@Component({
    components: {
        Input,
        Button,
        DatePickerSingle,
        // HourSelector,
        SimpleTable,
        MultipleSelect
    }
})
export default class ModalReprocessSowingInfo extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: false}) isSowing: boolean;
    @Prop() vehicleID: number;
    @Prop({default: null}) sowingReprocessData: sowingReprocessData | null;
    @Prop({default(){return []}}) vehicles: Array<object>;
    modalTitle: string = 'Reprocesado de ';
    last_update: string = ' - ';
    itemsDaysToReprocess: Array<object> = [];
    headersDaysToReprocess: Array<object> = [
        {
            text: 'Vehículo',
            value: 'vehicle_id',
            width: '200px',
            sortable: true
        },
        {
            text: 'Fecha Inicio',
            value: 'start',
            width: '200px',
            formatter: this.dateFormatter,
            sortable: true
        },
        {
            text: 'Fecha Fin',
            value: 'end',
            width: '200px',
            formatter: this.dateFormatter,
            sortable: true
        },
        {
            text: 'Recalcular Estado de Trabajo (IA)',
            value: 'recalculate_periods',
            align: 'center',
            formatter: this.parseBoolean,
            sortable: true
        },
    ]
    itemsVehiclesToReprocess: Array<object> = [];
    headersVehiclesToReprocess: Array<object> = [
        {
            text: 'Vehículo',
            value: 'vehicle_id',
            width: '200px',
            sortable: true
        },
        {
            text: 'Fecha',
            value: 'date',
            width: '200px',
            sortable: true,
            formatter: this.dateFormatter
        },
        {
            text: 'Recalcular Estado de Trabajo (IA)',
            value: 'recalculate_periods',
            align: 'center',
            formatter: this.parseBoolean,
            sortable: true
        },
    ];

    dateFormatter(value) {
        return formattedDate(value, true);
    }

    parseBoolean(value) {
        return booleanFormatter(value);
    }

   
    @Emit()
    closeModal() {}

    setModalTitle(){
        if(this.isSowing){
             this.modalTitle += '<b>Siembra</b>'
        }else{
            this.modalTitle += '<b>Cosecha</b>'
        }
    }
 

    mounted() {
       this.setModalTitle();
       if(this.sowingReprocessData !== null){
        if(this.sowingReprocessData && this.sowingReprocessData.last_status_update.indexOf('T') > -1){
            this.last_update = this.dateFormatter(this.sowingReprocessData.last_status_update)
        }

        if(this.sowingReprocessData && this.sowingReprocessData){
            this.setVehiclesToReprocess(this.sowingReprocessData.vehicles_to_reprocess);
        }
        this.itemsDaysToReprocess = this.getParsedItems(this.sowingReprocessData.days_to_reprocess, 1);
       }
    }

    setVehiclesToReprocess(vehiclesToReprocess: sowingReprocessData["vehicles_to_reprocess"]){
        if(vehiclesToReprocess){
           this.itemsVehiclesToReprocess = this.getParsedItems(vehiclesToReprocess, 2);
        }
    }

    getParsedItems(dict: sowingReprocessData["days_to_reprocess"] | sowingReprocessData["vehicles_to_reprocess"], type: number){
       let arr:any = [];
       let self = this;
        // console.log("dict", dict);
       let hasData = Object.values(dict).length > 0 ? true : false
       if(!hasData){
        return []
       }
    
       let values = Object.values(dict); 
       let keys = Object.keys(dict); 
        for (let index = 0; index < keys.length; index++) {
            let vehicleId = keys[index];
            let uniqueId = getUniqueId();
            let rows = values[index];
            let vehicleName = vehicleId;
            if(this.vehicles.length > 0){
                let indexInVehiclesList = getIndexFromList(self.vehicles, 'id', vehicleId);
                if(indexInVehiclesList !== -1){
                    let vehicleVin = self.vehicles[indexInVehiclesList]['vin'];
                    let vehicleDescription =  self.vehicles[indexInVehiclesList]['description']
                    if(vehicleVin !== null){
                        vehicleName = self.vehicles[indexInVehiclesList]['vin'] + ' ' + vehicleDescription
                    }else{
                        vehicleName = vehicleDescription
                    }
                }
            }
            if(type == 2){
                arr.push({
                    ...rows,
                    id: uniqueId,
                    vehicle_id: vehicleName
                });
            }else{
                rows = rows.map(function(row){
                    return {
                        ...row,
                        id: uniqueId,
                        vehicle_id: vehicleName
                    }
                })
                arr = [
                    ...arr,
                    ...rows
                ]
            }
            // console.log("rows", rows);
            
            
        }
      return arr
    }
}
